var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddReaction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.008 17.474c4.632 0 8.467-3.844 8.467-8.467C17.475 4.375 13.63.54 9 .54 4.376.54.54 4.375.54 9.007c0 4.623 3.843 8.467 8.467 8.467Zm0-1.412A7.022 7.022 0 0 1 1.96 9.008 7.015 7.015 0 0 1 9 1.95a7.036 7.036 0 0 1 7.064 7.056 7.029 7.029 0 0 1-7.056 7.056ZM6.542 8.268c.523 0 .988-.473.988-1.137 0-.673-.456-1.146-.988-1.146-.522 0-.979.473-.979 1.146 0 .664.457 1.137.98 1.137Zm4.923 0c.523 0 .988-.473.988-1.137 0-.673-.457-1.146-.988-1.146-.523 0-.98.473-.98 1.146 0 .664.457 1.137.98 1.137ZM9 13.165c1.734 0 2.896-1.153 2.896-1.701 0-.2-.19-.29-.365-.208-.606.332-1.328.706-2.531.706-1.204 0-1.926-.382-2.524-.706-.183-.083-.373.009-.373.208 0 .548 1.162 1.701 2.897 1.701Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddReaction);
export default __webpack_public_path__ + "static/media/addReaction.6e71cf407b5e9c2e1f4466610b776f65.svg";
export { ForwardRef as ReactComponent };